import React from "react";
import {View, Text, TouchableOpacity, Modal, StyleSheet, Dimensions} from 'react-native';
import { Image } from 'expo-image';

import {RFValue} from "react-native-responsive-fontsize";
import Config from "../../Config";
const Loading = ()=>{
    return (
        <Modal animationType="none" style={styles.container} transparent={false} visible={true} onRequestClose={()=>{}}>
            <View style={{height : Dimensions.get("window").height, backgroundColor : Config.maincolor, justifyContent : "center", alignItems: "center"}}>
                <Image
                    contentFit="contain"
                    transition={1000}
                    styles={styles.image}

                    source={require('../../assets/images/ring.gif')} style={styles.image} />
                <Image
                    contentFit="contain"
                    transition={1000}
                    styles={styles.image}

                    source={require('../../assets/images/himora.gif')} style={styles.image2} />

                {/*<Image*/}
                {/*    contentFit="scale-down"*/}
                {/*    transition={1000}*/}
                {/*    styles={styles.image} source={{uri : 'https://cdn.dribbble.com/users/2631479/screenshots/15375618/media/ed681d9afcaed97de7d934303a2dc7da.gif'}}*/}
                {/*    style={styles.image}*/}
                {/*/>*/}
            </View>
        </Modal>
    );
}

const styles =StyleSheet.create( {
  image: {
      width:RFValue(250),
      height: RFValue(250),
      backgroundColor : '#0D1134',
      resizeMode: 'contain',
      marginTop : -RFValue(60),
      // marginTop :'60%',
  },
    image2: {
        width:RFValue(250),
        height: RFValue(100),
        // backgroundColor : '#0D1134',
        // resizeMode: 'contain',
        // marginTop :'60%',
    },

});


export default Loading